import { useNavigation, useRoute } from "@react-navigation/core";
import React from "react";
import { Text, View, StyleSheet } from "react-native";
import { Button } from "../../components/Button";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useMutation, useQueryClient } from "react-query";
import { CreateReservationMutationFn } from "../../api/publicApi";
import { useDeviceToken } from "../../components/App/AuthContext";

interface RouteParams {
  dimension: string;
  doorPosition: string;
  lockerId: string;
}

export const ConfirmBike: React.FC = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const deviceToken = useDeviceToken();
  const queryClient = useQueryClient();
  const { dimension, lockerId, doorPosition } = route.params as RouteParams;

  const mutation = useMutation(CreateReservationMutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries("reservations");
      queryClient.invalidateQueries("bikes");
      navigation.navigate("Home");
    },
    onError: () => {},
  });

  return (
    <View style={{ flex: 1, alignItems: "center", marginTop: 20 }}>
      {mutation.error && (
        <Text style={styles.error}>
          Une erreur est survenue lors de la création de la réservation.
        </Text>
      )}

      <MaterialCommunityIcons name="bike-fast" size={44} color="#0D99D6" />
      <Text style={{ marginTop: 20 }}>
        Voulez-vous effectuer la réservation de{" "}
        <strong style={{ textTransform: "capitalize" }}>{dimension}</strong>?
      </Text>
      <Button
        style={{ marginTop: 20 }}
        title="Réserver"
        onPress={() =>
          mutation.mutate({
            deviceToken,
            locker_id: lockerId,
            door_position: doorPosition,
            notify_sender: false,
            notify_receiver: false,
          })
        }
        disabled={mutation.isLoading}
        loading={mutation.isLoading}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  error: {
    backgroundColor: "#fffbe6",
    marginTop: 15,
    paddingHorizontal: 15,
    paddingVertical: 8,
    textAlign: "center",
    borderWidth: 1,
    borderColor: "#ffecb5",
    color: "#664d03",
    marginBottom: 15,
  },
});
